import { createMap } from "@omnia/shared/utils/array"
import { IDataLayer, IDatalayerContext, isArrayEmpty, LayerTypeId, LayerViewModel, omniaDefer, omniaResolve, runOnLayersLoaded } from "../omnia"
import { IDatalayersService } from "../types"
import { isResourceAccessible } from "@omnia/shared/permissions/holding/accessRestrictions"

/**
 * This is called when the menu is being refreshed, to replace the layers currently being displayed
 * ({@see current}) by a new list of layers downloaded provided by the API
 *
 * @param updated New list of layers
 * @param current Current list of layers
 */
export function replaceLayers(updated: LayerViewModel[], current: LayerViewModel[]): PromiseLike<LayerViewModel[]> {

    current = (current || []).filter(l => l.visible)

    if (isArrayEmpty(current)) {
        return omniaResolve(updated)
    }

    const index = new Map(updated.map(c => [c.datalayerId, c]))

    // TODO: the stack order of the visible layers must be taken into account
    // Sort @current by stack order (deeper first) so as to make sure
    // that all layers will be restored in the right order
    const visible = current.map(l => {

        const u = index.get(l.datalayerId)

        if (u) {
            u.setVisible(true)
            u.opacity = l.opacity
            u.showLabels = l.showLabels
            u.showTooltips = l.showTooltips
        }

        return u

    }).filter(u => !!u)


    // TODO: layer variants?

    const d = omniaDefer<LayerViewModel[]>()

    runOnLayersLoaded(visible, () => {
        d.resolve(updated)
        current.forEach(c => c.dispose())
    })

    return d.promise

}
